<template>
  <!--分类页面-->
  <tk-container
    :status="status"
    style="background: #fff;"
    disableScroll
    @refresh="getInit"
  >
    <!--头部-->
    <tkui-header
      slot="header"
      class="flex-header"
    >
      <!--搜索跳转框-->
      <div class="flex-header-search" @click="nextSearchPage">
        <tk-flex center middle class="fill" >
          <tkui-button class="icon flex-icon m-0 m-l-10">
            <tk-icon size="16" color="#bbb">search</tk-icon>
          </tkui-button>
          <div class="m-l-10">点击搜索</div>
        </tk-flex>
      </div>
    </tkui-header>
    <!--分类渲染-->
    <tk-flex
      class="full-height"
    >
      <!--左边一级分类渲染-->
      <tk-container
        class="tk-grid-3 class-left"
        v-if="firstClassification.length"
        style="height:calc(100% - 16px)"
      >
        <tk-flex
          column
          center
          class="p-16"
          @click.native="toggleFirstClass(index, s.objectId)"
          v-for="(s, index) in firstClassification"
          :key="index"
          :id="`left${s.objectId}`"
        >
          <div :class="{'class-left-active': s.leftActive}" class="font-13 class-left-item"
               style="color: rgba(102, 102, 102, 1);"
          >{{s.name}}</div>
        </tk-flex>
      </tk-container>
      <!--右边二级分类渲染-->
      <tk-container
        class="class-right tk-grid-9"
        :status="rightStatus"
        ref="scrollViewRight"
        style="height:calc(100% - 10px)"
      >
        <div style="height: 10px;"></div>
        <div v-if="firstClassData && firstClassData.objectId === 'promotion'">
          <div class="m-x-10 m-b-10 class-right-image" v-if="firstClassData">
            <tk-image :src="firstClassData.image" @click.native="goProduct" style="width: 100%;height: 80px;" height="80"></tk-image>
          </div>
          <div
            class="class-right-flex m-x-10"
            v-if="secondaryClassification && secondaryClassification.length"
          >
            <div
              class="p-5"
            >
              <tk-flex
                wrap
                :gutter="5"
              >
                <tk-flex
                  column
                  center
                  v-for="(s, index) in secondaryClassification"
                  @click.native="$push({ path: '/commodity/productDetails', query: { id: s.objectId } })"
                  :key="`class-right${index}`"
                  :id="`right${s.objectId}`"
                  class="tk-grid-4 m-b-15"
                >
                  <tk-image :src="s.showPictures.length ? s.showPictures[0] : ''" width="120" height="120"></tk-image>
                  <div class="m-t-5 font-12" style="color: rgba(102, 102, 102, 1);">{{s.productTitle}}</div>
                </tk-flex>
              </tk-flex>
            </div>
          </div>
          <tk-flex
            center
            middle
            v-else
            class="class-right-flex caption m-x-10"
            :style="calculationRH()"
          >
            暂无数据
          </tk-flex>
        </div>
        <div v-else>
          <div class="m-x-10 m-b-10 class-right-image" v-if="firstClassData">
            <tk-image :src="firstClassData.image" @click.native="goProduct" style="width: 100%;height: 80px;" height="80"></tk-image>
          </div>
          <div
            class="class-right-flex m-x-10"
            v-if="secondaryClassification"
          >
            <tk-flex
              column
              class="p-5"
              v-for="(s, index) in secondaryClassification"
              :key="`class-right${index}`"
              :id="`right${s.objectId}`"
            >
              <tk-flex
                wrap
                :gutter="5"
                class="full"
              >
                <tk-flex
                  column
                  center
                  class="tk-grid-4 m-b-15"
                  @click.native="nextPage(m)"
                  v-for="(m, index) in s.data"
                  :key="`class-right-flex${index}`"
                >
                  <tk-image :src="m.image" width="120" height="120"></tk-image>
                  <div class="m-t-5 font-12" style="color: rgba(102, 102, 102, 1);">{{m.name}}</div>
                </tk-flex>
              </tk-flex>
            </tk-flex>
          </div>
          <tk-flex
            center
            middle
            v-else
            class="class-right-flex caption m-x-10"
            :style="calculationRH()"
          >
            暂无数据
          </tk-flex>
        </div>
        <div style="height: 10px;"></div>
      </tk-container>
    </tk-flex>
  </tk-container>
</template>
<script>
import { priceProcessing } from '@/assets/help/tool'
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      rightStatus: false, // 右边页面状态
      timeRule: {}, // 限时抢购时间规则
      watchScrollStatus: false, // 切换页面归零状态
      currentIndex: 0, // 当前所处分类的index
      firstClassification: [], // 商品一级分类数据
      secondaryClassification: null // 商品二级分类数据
    }
  },
  computed: {
    // 向上拉继续浏览
    upName () {
      if (!this.firstClassification[this.currentIndex + 1]) { return '' }
      return this.firstClassification[this.currentIndex + 1].name
    },
    // 向下拉继续浏览
    downName () {
      if (this.currentIndex - 1 < 0 || !this.firstClassification[this.currentIndex - 1]) { return '' }
      return this.firstClassification[this.currentIndex - 1].name
    },
    // 一级分类推广图片
    firstClassData () {
      return this.firstClassification[this.currentIndex]
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  activated () {
    this.setStatusBar('dark')
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
    * 数据初始化
    * @date: 2020/3/24
    */
    async getInit () {
      try {
        await this.getFirstClassification() // 获得商品一级分类
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        let id = await this.getLightUpClassId() // 获取点亮的一级分类id
        if (id) {
          await this.getSecondaryClassification(id)
          this.currentIndex = 0
        }
        // 获得商品二级分类
        if (!this.firstClassification.length || !this.secondaryClassification) {
          this.status = 'empty'
          return
        }
        if (this.$refs.scrollViewRight) {
          let BScroll = this.$refs.scrollViewRight.scrollIntance
          BScroll.on('scrollEnd', async () => {
            // if (this.watchScrollStatus) { return }
            // await this.scrollWatchEnd()
          })
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
    * 获得商品一级分类
    * @tableName { firstClassification }
    * @date: 2020/3/24
    */
    async getFirstClassification () {
      let firstClassification = await this.$tkParse.getList(`/classes/firstClassification`, {
        params: {
          limit: 1000,
          order: 'weight',
          include: 'link',
          where: {
            objectId: {
              $ne: 'tzC3HnKB50'
            }
          }
        }
      })
      let specifyClass = await this.$tkParse.getData(`/classes/firstClassification/tzC3HnKB50`)
      if (firstClassification.length) {
        firstClassification.unshift({
          name: '推荐商品',
          objectId: 'promotion',
          link: {
            objectId: specifyClass.link || ''
          },
          image: specifyClass.image || ''
        })
        this.firstClassification = firstClassification.map((s, index) => {
          s.leftActive = index === 0
          return s
        })
      } else {
        this.firstClassification = [{
          name: '推荐商品',
          id: 'promotion',
          link: specifyClass.link || '',
          image: specifyClass.image || ''
        }]
      }
    },
    getLightUpClassId () {
      if (!this.firstClassification.length) { return '' }
      return this.firstClassification[0].objectId
    },
    /**
    * 获得商品二级分类
    * @tableName { secondaryClassification }
    * @date: 2020/3/24
    */
    async getSecondaryClassification (id) {
      this.secondaryClassification = null
      if (id === 'promotion') {
        await this.getPromotionalGifts()
      } else {
        let secondaryClassification = await this.$tkParse.getList(`/classes/secondaryClassification`, {
          params: {
            limit: 1000,
            // order: 'createdAt',
            order: 'weight',
            include: ['category'],
            where: {
              category: id
            }
          }
        })
        let arr = secondaryClassification.filter(s => { return s.objectId !== '80dkpxb8rC' })
        let obj = {}
        arr.forEach(s => {
          if (obj[s.category.name]) {
            obj[s.category.name].data.push(s)
          } else {
            obj[s.category.name] = {}
            obj[s.category.name].name = s.category.name
            obj[s.category.name].objectId = s.category.objectId
            obj[s.category.name].data = [s]
          }
        })
        if (secondaryClassification.length) { this.secondaryClassification = obj } else { this.secondaryClassification = null }
      }
    },
    /**
     * 促销礼品数据获取
     * @date: 2020/3/20
     */
    async getPromotionalGifts () {
      let promotionalGifts = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 3000,
          // order: '-createdAt',
          order: 'weight',
          where: { category: '80dkpxb8rC', shelvesStatus: 'shelves' }
        }
      })
      if (promotionalGifts.length) { this.secondaryClassification = priceProcessing(promotionalGifts, this.judgeTimeRule) } else { this.secondaryClassification = [] }
    },
    /**
    * 计算左边页面的高度
    * @date: 2020/3/24
    */
    calculationLH () {
      let height = document.body.clientHeight
      return `min-height: ${height - 105}px !important`
    },
    /**
     * 计算右边页面的高度
     * @date: 2020/3/24
     */
    calculationRH () {
      let height = document.body.clientHeight
      return `height: ${height - 105 - 20}px !important`
    },
    /**
    * 切到搜索页面
    * @date: 2020/4/27
    */
    nextSearchPage () {
      this.$setFlash('toggleSearch', 'class')
      this.$push('/common/searchPage')
    },
    /**
    * banner图片跳到详情
    * @date: 2020/4/27
    */
    goProduct () {
      if (!this.firstClassData.link) { return }
      this.$push({ path: '/commodity/productDetails', query: { id: this.firstClassData.link.objectId } })
    },
    /**
    * 切换一级分类
    * @date: 2020/3/24
    */
    async toggleFirstClass (num, id) {
      this.rightStatus = 'loading'
      // 修改状态数据
      this.firstClassification.forEach(s => { s.leftActive = false })
      this.firstClassification[num].leftActive = true
      this.$forceUpdate()
      await this.$tkHelper.sleep(200)
      // 按照一级分类获取二级分类数据
      await this.getSecondaryClassification(id)
      this.currentIndex = num
      this.rightStatus = false
    },
    /**
    * 监听页面滚动
    * @date: 2020/3/24
    */
    async scrollWatchEnd () {
      if (this.$refs.scrollViewRight.scrollIntance.movingDirectionY === 1 && this.upName) {
        this.watchScrollStatus = true
        await this.$tkHelper.sleep(0)
        await this.toggleFirstClass(this.currentIndex + 1, this.firstClassification[this.currentIndex + 1].objectId)
        this.$refs.scrollViewRight.scrollTo(0)
        await this.$tkHelper.sleep(1000)
        this.watchScrollStatus = false
      } else if (this.$refs.scrollViewRight.scrollIntance.movingDirectionY === -1 && this.downName) {
        await this.$tkHelper.sleep(0)
        await this.toggleFirstClass(this.currentIndex - 1, this.firstClassification[this.currentIndex - 1].objectId)
      }
    },
    /**
    * 商品页面
    * @date: 2020/4/10
    */
    nextPage (s) {
      this.$setFlash('searchWord', s.name)
      this.$push({ path: '/common/commodityList', query: { classId: s.objectId, type: 'class' } })
    }
  }
}
</script>
<style lang="scss" scoped>
  /*头部样式*/
  .flex-header {
    border-bottom: none !important;
    padding: 0 20px !important;
    .flex-header-search {
      height: 30px;
      width: 100%;
      line-height: 30px;
      font-size: 14px;
      color: #bbb;
      background-color: rgba(242, 242, 242, 1);
      margin: 0 12px;
      border-radius: 16px;
      .flex-icon {
        width: 16px;height: 16px;margin-top: 8px;
      }
    }
  }
  /*分类样式*/
  .class-left {
    background: #fff !important;
  }
  .class-left-item{
    width: 72px;
    height: 24px;
    line-height: 25px;
    text-align: center;
  }
  .class-left-active {
    border-radius: 12px;
    font-weight: bold;
    color: rgba(255, 254, 254, 1) !important;
    background:linear-gradient(90deg,rgba(248,69,39,1),rgba(207,22,19,1));
  }
  .class-right {
    background: #f5f5f5 !important;
    .class-right-image {
      height: 80px;
      overflow: hidden;
      border-radius: 5px;
    }
    .class-right-flex {
      background: #fff;
    }
  }
</style>
